/* Raven countdown bar — moved out of the header inline script so it no longer
   blocks HTML parsing. Initializes every [data-raven-cd] root. */
(function () {
  'use strict';

  var TZ = 'America/New_York';

  function parseTzParts(ms, tzName) {
    var f = new Intl.DateTimeFormat('en-US', {
      timeZone: tzName,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
    var parts = {};
    f.formatToParts(new Date(ms)).forEach(function (x) {
      if (x.type !== 'literal') parts[x.type] = x.value;
    });
    return {
      y: Number(parts.year),
      mo: Number(parts.month),
      d: Number(parts.day),
      h: Number(parts.hour),
      m: Number(parts.minute),
      s: Number(parts.second),
    };
  }

  function weekdaySunday0(y, mo, d) {
    return new Date(Date.UTC(y, mo - 1, d, 12, 0, 0)).getUTCDay();
  }

  function cmpWall(a, y, mo, d, h, mi) {
    if (a.y !== y) return a.y - y;
    if (a.mo !== mo) return a.mo - mo;
    if (a.d !== d) return a.d - d;
    if (a.h !== h) return a.h - h;
    return a.m - mi;
  }

  function wallToUtc(y, mo, d, h, mi, tzName) {
    var lo = Date.UTC(y, mo - 1, d) - 12 * 3600000;
    var hi = Date.UTC(y, mo - 1, d) + 36 * 3600000;
    var mid, cmp, t, u, p, step;
    while (hi - lo > 400) {
      mid = (lo + hi) / 2;
      cmp = cmpWall(parseTzParts(mid, tzName), y, mo, d, h, mi);
      if (cmp < 0) lo = mid;
      else hi = mid;
    }
    t = Math.round((lo + hi) / 2);
    for (step = -120000; step <= 120000; step += 60000) {
      u = t + step;
      p = parseTzParts(u, tzName);
      if (p.y === y && p.mo === mo && p.d === d && p.h === h && p.m === mi) return u;
    }
    return t;
  }

  function addGregorianDays(y, mo, d, delta) {
    var u = Date.UTC(y, mo - 1, d + delta);
    var dt = new Date(u);
    return { y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
  }

  function nextMondayGregorian(y, mo, d, wd) {
    var add = (8 - wd) % 7;
    if (add === 0) add = 7;
    return addGregorianDays(y, mo, d, add);
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function formatHMS(msLeft) {
    if (msLeft <= 0) return '00:00:00';
    var sec = Math.floor(msLeft / 1000);
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    return pad2(h) + ':' + pad2(m) + ':' + pad2(s);
  }

  function shipLabelFromMessage(msg) {
    if (!msg) return 'SHIPS TODAY';
    if (msg.indexOf('Monday') !== -1) return 'SHIPS MONDAY';
    if (msg.indexOf('Tomorrow') !== -1) return 'SHIPS TOMORROW';
    return 'SHIPS TODAY';
  }

  function initRoot(root) {
    function syncPageOffset() {
      var h = root.offsetHeight || 0;
      document.documentElement.style.setProperty('--raven-countdown-offset', h + 'px');
    }

    syncPageOffset();
    window.addEventListener('resize', syncPageOffset, { passive: true });

    if (root.dataset.timer !== 'true') return;

    var cutoffH = Number(root.dataset.cutoffHour) || 14;
    var cutoffM = Number(root.dataset.cutoffMinute) || 0;

    function resolveShippingState(nowMs) {
      var p = parseTzParts(nowMs, TZ);
      var wd = weekdaySunday0(p.y, p.mo, p.d); // 0 Sun ... 6 Sat
      var nowMinutes = p.h * 60 + p.m;
      var cutoffMinutes = cutoffH * 60 + cutoffM;
      var isBeforeCutoff = nowMinutes < cutoffMinutes;
      var target;
      var msg;

      if (wd === 6 || wd === 0) {
        target = nextMondayGregorian(p.y, p.mo, p.d, wd);
        msg = 'Ships Monday if ordered in:';
      } else if (wd === 5 && !isBeforeCutoff) {
        target = nextMondayGregorian(p.y, p.mo, p.d, wd);
        msg = 'Ships Monday if ordered in:';
      } else if (isBeforeCutoff) {
        target = { y: p.y, mo: p.mo, d: p.d };
        msg = 'Ships Today if ordered in:';
      } else {
        target = addGregorianDays(p.y, p.mo, p.d, 1);
        msg = 'Ships Tomorrow if ordered in:';
      }

      return {
        ts: wallToUtc(target.y, target.mo, target.d, cutoffH, cutoffM, TZ),
        message: msg,
      };
    }

    var digits = root.querySelector('[data-raven-cd-digits]');
    var timeEl = root.querySelector('[data-raven-cd-timer]');
    var labelEl = root.querySelector('[data-raven-cd-label]');
    var shipEl = root.querySelector('[data-raven-cd-ship]');
    var rotateItem = root.querySelector('[data-raven-cd-rotate-item]');

    function tick() {
      var now = Date.now();
      var solved = resolveShippingState(now);

      if (!digits) return;

      if (!solved) {
        digits.textContent = '00:00:00';
        if (timeEl) timeEl.removeAttribute('datetime');
        if (labelEl) labelEl.textContent = 'Ships Monday if ordered in:';
        if (shipEl) shipEl.textContent = 'SHIPS MONDAY';
        return;
      }

      if (labelEl) labelEl.textContent = solved.message;
      if (shipEl) shipEl.textContent = shipLabelFromMessage(solved.message);

      digits.textContent = formatHMS(solved.ts - now);
      if (timeEl) timeEl.setAttribute('datetime', new Date(solved.ts).toISOString());
    }

    tick();
    setInterval(tick, 1000);

    var rotateSlides = [];
    function pushSlide(text) {
      var t = (text || '').trim();
      if (t && rotateSlides.indexOf(t) === -1) rotateSlides.push(t);
    }
    if (shipEl && digits) {
      pushSlide(shipEl.textContent.trim() + ' · ' + digits.textContent);
    }
    root.querySelectorAll('.raven-cd__badge').forEach(function (el) {
      pushSlide(el.textContent);
    });

    var rotateIndex = 0;
    function cycleRotate() {
      if (!rotateItem || rotateSlides.length < 2) return;
      if (window.matchMedia('(min-width: 750px)').matches) return;
      rotateIndex = (rotateIndex + 1) % rotateSlides.length;
      rotateItem.textContent = rotateSlides[rotateIndex];
    }

    if (rotateItem && rotateSlides.length > 0) {
      rotateItem.textContent = rotateSlides[0];
    }
    if (rotateSlides.length > 1) {
      setInterval(cycleRotate, 4000);
    }
  }

  document.querySelectorAll('[data-raven-cd]').forEach(initRoot);
})();
